import { createStore } from 'vuex'

const URL = 'https://server-web.konaweselatankab.go.id/';
const URL_SIMPEG = 'https://server-egov.konaweselatankab.go.id/';
var UNIT = 'NjJkhCuQDcDTaurPZ';

export default createStore({
  state: {
    UNIT_KERJA : UNIT,
    url: {
      URL_APP_SIMPEG: URL_SIMPEG, 
      URL_APP: URL,
      URL_SLIDER: URL + 'api/v1/publish_disparekraf_slider/',
      URL_BERITA: URL + 'api/v1/web_publish_berita/',
      URL_SAMBUTAN: URL + 'api/v1/publish_disparekraf_sambutan/',
      URL_LINK_TERKAIT: URL + 'api/v1/web_publish_link_terkait/',
      URL_FOTO: URL + 'api/v1/publish_disparekraf_foto/',
      URL_DATA_PEGAWAI: URL + 'api/v1/publish_disparekraf_data_pegawai/',
      URL_PRODUK_HUKUM: URL + 'api/v1/publish_disparekraf_produk_hukum/',
      URL_SEJARAH: URL + 'api/v1/publish_disparekraf_sejarah/',
      URL_TENTANG_KAMI: URL + 'api/v1/publish_disparekraf_tentang_kami/',
      URL_TUGAS_POKOK: URL + 'api/v1/publish_disparekraf_tupoksi/',
      URL_VISI_MISI: URL + 'api/v1/publish_disparekraf_visi_misi/',
      URL_STRUKTUR_ORGANISASI: URL + 'api/v1/publish_disparekraf_struktur_organisasi/',
      URL_UNIT_KERJA: URL + 'api/v1/publish_disparekraf_unit_kerja/',
      URL_PARIWISATA: URL + 'api/v1/publish_disparekraf_pariwisata/',
      URL_EKRAF: URL + 'api/v1/publish_disparekraf_ekraf/',
      URL_VIDEO: URL + 'api/v1/publish_disparekraf_video/',
      URL_EVENT: URL + 'api/v1/publish_disparekraf_event/',
    },
  },
  getters: {
  },
  mutations: {
  },
  actions: {
  },
  modules: {
  }
})
